import { Dispatch, ThunkAction } from '../../../types/actions';
import { TBoardId, TCardId } from '../../../types/types';
import { boardUpdateMeta } from './boardUpdateMeta';

export const boardSetDefaultTemplateCardIdMeta = (
    boardId: TBoardId,
    defaultTemplateCardId: TCardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        return dispatch(boardUpdateMeta(boardId, { defaultTemplateCardId }));
    };
    return action;
};
